import { breakPointOrder } from "../../theme-provider/theme-provider.mjs";
import { useCurrentBreakPoint } from "./use-current-breakpoint.mjs";
function useResponsiveProps({ responsive }) {
  const responsiveBreakPoints = responsive.map((resp) => resp.breakPoint);
  const currentBreakPoint = useCurrentBreakPoint();
  const getActiveBreakPoints = (currentBreakPoint2, responsiveBP) => {
    const sortedResponsiveBreakPoints = responsiveBP.sort((x, y) => breakPointOrder.indexOf(x) - breakPointOrder.indexOf(y));
    return sortedResponsiveBreakPoints.filter((breakPoint) => {
      return breakPointOrder.indexOf(breakPoint) <= breakPointOrder.indexOf(currentBreakPoint2);
    });
  };
  const getResponsiveProps = (breakPoint) => {
    const responsiveObject = responsive.find((resp) => resp.breakPoint === breakPoint);
    if (responsiveObject) {
      return responsiveObject.props;
    }
  };
  if (!currentBreakPoint) {
    return {};
  }
  const activeBreakPoints = getActiveBreakPoints(currentBreakPoint, responsiveBreakPoints);
  return activeBreakPoints.reduce((acc, breakPoint) => ({ ...acc, ...getResponsiveProps(breakPoint) }), {});
}
export {
  useResponsiveProps
};
